/**
 * Mobility — directional arrows either side of the crown with a Roman-numeral
 * grade badge (I/II/III) above. Read the grade from the condition's optional
 * `grade` prop; falls back to grade I.
 */
export default function Mobility({ grade = "I" }) {
  return (
    <g style={{ pointerEvents: "none" }}>
      {/* Left arrow */}
      <path d="M 10 60 L 4 64 L 10 68 Z" fill="#8A3F1E" />
      <line x1={10} y1={64} x2={20} y2={64}
            stroke="#8A3F1E" strokeWidth={1.4} strokeLinecap="round" />
      {/* Right arrow */}
      <path d="M 50 60 L 56 64 L 50 68 Z" fill="#8A3F1E" />
      <line x1={40} y1={64} x2={50} y2={64}
            stroke="#8A3F1E" strokeWidth={1.4} strokeLinecap="round" />

      {/* Grade badge */}
      <g transform="translate(30 12)">
        <rect x={-9} y={-8} width={18} height={12} rx={4}
              fill="#FDF3ED" stroke="#8A3F1E" strokeWidth={0.8} />
        <text x={0} y={1} textAnchor="middle"
              fontSize={8}
              fontFamily="ui-sans-serif, system-ui, sans-serif"
              fontWeight={700}
              fill="#8A3F1E">
          {String(grade || "I").toUpperCase()}
        </text>
      </g>
    </g>
  );
}
